<template>
<div class="container">
<b-row v-if="!isLoading">
<h5>
	<label for="desde">Desde</label> &nbsp;
	<input type="date" name="" id="desde" v-model="desde" @click="desde='';hasta='';pais='';paises=false;muestreLista=false">&nbsp; 
	<label for="hasta">Hasta</label> &nbsp;
	<input type="date" name="" id="hasta" v-model="hasta" @click="hasta='';pais='';paises=false" @input="f_seleccione_pais()">&nbsp; 
	<label v-if="paises">País</label> &nbsp;
	<select v-if="paises" v-model="pais" @click="f_restaure_botones()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
	<span v-if="pais && paises">
		&nbsp;<label >Consulta por:</label> &nbsp;
		<label >Fecha</label> &nbsp;
		<input type="checkbox" id="Fecha" value="Fecha" v-on:click="uncheck(1)" > &nbsp; &nbsp;
		<label >Líder</label> &nbsp;
		<input type="checkbox" id="Lider" value="Lider" v-on:click="uncheck(2)"> &nbsp;&nbsp;		
		<label >Usuario</label> &nbsp;
		<input type="checkbox" id="Usuario" value="Usuario" v-on:click="uncheck(3)">
	</span>
</h5>
<b-container v-if="muestreLista">
	<md-table v-model="listFacturas" md-card md-fixed-header @md-selected="f_muestra">
	<md-table-toolbar>
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
		<md-table-cell v-if="Lider" :md-label="labels.lider" class="text-left border">{{item.id_lider}}</md-table-cell>
		<md-table-cell v-if="Lider" :md-label="labels.lider_nombre" class="text-left border">{{item.name}}</md-table-cell>
		<md-table-cell v-if="Usuario" :md-label="labels.usuario" class="text-left border">{{item.id_usuario}}</md-table-cell>
		<md-table-cell v-if="Usuario" :md-label="labels.usuario_nombre" class="text-left border">{{item.name}}</md-table-cell>
		<md-table-cell :md-label="labels.cantidad" class="text-left border">{{item.cantidad}}</md-table-cell>
		<md-table-cell :md-label="labels.items" class="text-left border">{{item.items}}</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
<md-dialog :md-active.sync="muestreFacturas">
	<md-dialog-title class="text-center"><h3><b><i>{{f_titulo()}}</i></b>
	</h3></md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listFacturasCliente" md-card md-fixed-header @md-selected="f_muestra_detalle">
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
				<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.documento" class="text-left border">{{item.documento}}</md-table-cell>
				<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
				<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
				<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
				<md-table-cell :md-label="labels.impuesto" class="text-right border">{{item.impuesto_total}}</md-table-cell>
				<md-table-cell :md-label="labels.valor_total" class="text-right border">{{item.valor_total}}</md-table-cell>
				<md-table-cell :md-label="labels.items" class="text-right border">{{item.items}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button class="md-accent" @click="muestreFacturas = false">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="muestreDetalleFacturas">
	<md-dialog-content>
		<md-table >
			<md-table-row >
				<md-table-cell v-if="factura.documento=='NC'" class="text-right border">Nota Credito</md-table-cell>
				<md-table-cell v-else class="text-right border">Factura</md-table-cell>
				<md-table-cell class="text-left border">{{factura.fecha_factura}}</md-table-cell>
				<md-table-cell class="text-left border">{{factura.factura}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Identificación</md-table-cell>
				<md-table-cell class="text-left border">{{factura.identificacion}}</md-table-cell>
				<md-table-cell class="text-left border">{{factura.nombre}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Pedido/Remision</md-table-cell>
				<md-table-cell class="text-left border">{{factura.pedido}}</md-table-cell>
				<md-table-cell v-if="factura.remision != 'NULL'" class="text-left border">{{factura.remision}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria0 != 'NULL'">
				<md-table-cell class="text-right border">Impuesto(s)</md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria0}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto0}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria1 != 'NULL'">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria1}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto1}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria2 != 'NULL'">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria2}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto2}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Valor</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.valor}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Impuesto(s)</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto_total}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Total</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.valor_total}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.id_lider >0">
				<md-table-cell class="text-right border">Líder</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_lider)}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.id_usuario >0">
				<md-table-cell class="text-right border">Asignado</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
			<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_usuario)}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button class="md-accent" @click="muestreDetalleFacturas = false">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
</b-row>
</div>
</template>
<script>
import Seguimiento from "@/services/Seguimiento"
import User from "@/services/User"

export default {
name:'Seguimiento',
data: () => ({
	isLoading: false,
	Fecha : false,
	Lider : false,
	Usuario : false,
	desde: '',
	hasta: '',
	opcion: 0,
	muestreopciones: false,
	factura: '',
	pais: '',
	paises: false,
	titulo_factura: "",
	users : [],
	listPaises : [],
	listFacturas : [],
	listFacturasCliente : [],
	muestreLista: false,
	muestreFacturas: false,
	muestreDetalleFacturas: false,
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			factura : "Número Factura",
			fecha : "Fecha Factura",
			identificacion : "Número Identificación",
			proveedor : "Nombre del Proveedor",
			cantidad : "Facturas",
			pedido : "Número Pedido",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			lider: "Líder",
			lider_nombre:   "........................................  Nombre del Líder .............................................",
			usuario: "Usuario",
			usuario_nombre: ".......................................  Nombre del Usuario ............................................",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			lider: "Leader",
			lider_nombre: "Leader Name",
			usuario: "User",
			usuario_nombre: "User Name",
		}
	}
}
},
mounted(){
	if	(this.$route.name == "sporasignar") {
		this.opcion=0
	}
	if	(this.$route.name == "sporcontabilizar") {
		this.opcion=1
	}
	if	(this.$route.name == "scontabilizadas") {
		this.opcion=2
	}
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
},
methods:{
	f_titulo() {
		if	(this.$route.name == "sporasignar") {
			return "CONSULTA FACTURAS POR ASIGNAR"
		}
		if	(this.$route.name == "sporcontabilizar") {
			return "CONSULTA FACTURAS POR CONTABILIZAR"
		}
		if	(this.$route.name == "scontabilizadas") {
			return "CONSULTA FACTURAS CONTABILIZADAS"
		}
		return "SIN INFORMACION "+this.$route.name
	},
	f_muestra(r_proveedor) {
		let fgl_lider = null
		let fgl_usuario = null
		if	(this.Lider) {
			fgl_lider = r_proveedor.id_lider
		}
		if	(this.Usuario) {
			fgl_usuario = r_proveedor.id_usuario
		}
		this.muestreFacturas=true
		Seguimiento.leaFacturasCliente(this.pais,r_proveedor.fecha_factura,this.opcion,fgl_lider,fgl_usuario)
		.then((res) => {
			this.listFacturasCliente = res.data.listFacturasCliente
		})
		.catch((err) => {
			console.log(err)
		})
		
	},
	f_muestra_detalle(r_factura) {
		this.factura=r_factura
		this.muestreDetalleFacturas=true
	},
	f_usuario_nombre(id) {
		if	(id === undefined) {
			return "Indefinida"
		}
		const usuario = this.users.find((usuario) => usuario.id == id)
		return usuario.name
	},
	uncheck(opcion) {
		if	(this.$route.name == "sporasignar") {
			opcion=1
		}
		var operacion = ''
		var checkbox1 = document.getElementById("Fecha");
		var checkbox2 = document.getElementById("Lider");
		var checkbox3 = document.getElementById("Usuario");
		checkbox1.checked=false;
		checkbox2.checked=false;
		checkbox3.checked=false;
		this.Fecha=false;
		this.Lider=false;
		this.Usuario=false;
		if (opcion == 1) {
			checkbox1.checked=true;
			this.Fecha=true;
			operacion="fecha"
		}
		if (opcion == 2) {
			checkbox2.checked=true;
			this.Lider=true;
			operacion="lider"
		}
		if (opcion == 3) {
			checkbox3.checked=true;
			this.Usuario=true;
			operacion="usuario"
		}
		Seguimiento.leaFacturas(operacion,this.pais,this.opcion,this.desde,this.hasta)
		.then((res) => {
			this.listFacturas = res.data.listFacturas
			this.muestreLista=true
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_seleccione_facturas() {
		this.muestreLista=true
	},
	f_seleccione_pais() {
		this.listPaises = []
		this.paises=true
		if	(this.desde && this.hasta) {
			Seguimiento.leaPaises(this.opcion,this.desde,this.hasta)
			.then((res) => {
				this.listPaises = res.data.listPaises
				this.pais=''
				if	(this.listPaises.lenght>0) {
					this.paises=true
				}
			})
			.catch((err) => {
				console.log(err)
			})
		}
	},
	f_restaure_botones() {
		this.Fecha=false
		this.Lider=false
		this.Usuario=false
		var checkbox1 = document.getElementById("Fecha")
		var checkbox2 = document.getElementById("Lider")
		var checkbox3 = document.getElementById("Usuario")
		checkbox1.checked=false
		checkbox2.checked=false
		checkbox3.checked=false
		this.muestreLista=false
	},
}

}
</script>

<style>

</style>
